module.exports = __webpack_public_path__ + "static/media/left-arrow.0db6645f.svg";